import { render, staticRenderFns } from "./ORERecommendations.vue?vue&type=template&id=fff560ea&scoped=true"
import script from "./ORERecommendations.vue?vue&type=script&lang=js"
export * from "./ORERecommendations.vue?vue&type=script&lang=js"
import style0 from "./ORERecommendations.vue?vue&type=style&index=0&id=fff560ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff560ea",
  null
  
)

export default component.exports